import { render, staticRenderFns } from "./TradeNews1.vue?vue&type=template&id=8602142a&scoped=true&"
import script from "./TradeNews1.vue?vue&type=script&lang=js&"
export * from "./TradeNews1.vue?vue&type=script&lang=js&"
import style0 from "./TradeNews1.vue?vue&type=style&index=0&id=8602142a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8602142a",
  null
  
)

export default component.exports